import CountrySelectorMenu from './CountrySelectorMenu';
import './styles.scss';
import HeaderButton from '../HeaderButton';
import React from 'react';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import { useSelector } from 'react-redux';

const CountrySelector = () => {
    const [isOpen, setOpen] = React.useState(false);
    const { menu_change_country_text } = useSelector(selectTranslations);

    const onToggleMenu = () => setOpen(!isOpen);

    return (
        <div className="country-selector-container">
            <HeaderButton iconName="globe" text={menu_change_country_text} onClick={onToggleMenu} />
            {isOpen && <CountrySelectorMenu onClose={onToggleMenu} />}
        </div>
    );
};

export default CountrySelector;
